import React, { FC } from 'react';
import { SvgIcon } from '@material-ui/core';

const UniverseIcon: FC = ({ fill }: { fill: string }) => {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path fill={fill} d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" />
    </SvgIcon>
  );
};

export default UniverseIcon;
